import { render, staticRenderFns } from "./FeMonteContreras.vue?vue&type=template&id=53efdd14&"
import script from "./FeMonteContreras.vue?vue&type=script&lang=js&"
export * from "./FeMonteContreras.vue?vue&type=script&lang=js&"
import style0 from "./FeMonteContreras.vue?vue&type=style&index=0&id=53efdd14&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports